import { parseTimestamp } from "../../utils/functions";
import TemplateStars from "./templateStars";

export default function Review({ review }: { review: { rate: number, review: string, createdAt: Date } }) {
    return (
        <div className="flex flex-col w-full h-full">
            <div className="flex justify-between items-center mb-3">
                <div className="scale-90 origin-left">
                    <TemplateStars width="20px" rate={review?.rate} />
                </div>
                <span className="text-[10px] text-mono font-bold tracking-widest">{parseTimestamp(review?.createdAt)}</span>
            </div>
            <p className="text-sm text-primary leading-relaxed">{review?.review}</p>
        </div>
    )
}
